import { getFetchedDataPayload } from '@vista-digital/utilities';
import { temporaryLoyaltyDomainStore } from '../../temporary-store/store';
export const getMember = () => getFetchedDataPayload(temporaryLoyaltyDomainStore.data.member);
//# sourceMappingURL=get-member.js.map